import { all } from 'redux-saga/effects';
import userSaga from './user.saga';
import imageSaga from './image.saga';
import geolocationSaga from './geolocation.saga';
import boxofficeSaga from './boxoffice.saga';
import moviesSaga from './movies.saga';
import commentsSaga from './comments.saga';
import movieTheaterSaga from './movietheaters.saga';
import newsSaga from './news.saga';
import tagsSaga from './tags.saga';
import searchResultsSaga from './searchresults.saga';
import filtersSaga from './filters.saga';
import scheduleSaga from './schedule.saga';
import profileSaga from './profile.saga';
import festivalSaga from './festival.saga';
import editProfileSaga from './editprofile.saga';
import generalSaga from './general.saga';
import paymentSaga  from './payment.saga';
import pagesSaga from './pages.saga';

export default function* rootSaga() {
    yield all([
        userSaga(),
        imageSaga(),
        geolocationSaga(),
        boxofficeSaga(),
        moviesSaga(),
        commentsSaga(),
        movieTheaterSaga(),
        newsSaga(),
        tagsSaga(),
        searchResultsSaga(),
        filtersSaga(),
        scheduleSaga(),
        profileSaga(),
        festivalSaga(),
        editProfileSaga(),
        generalSaga(),
        paymentSaga(),
        pagesSaga()
    ])
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/root.saga.js